interface MatchCardWithPlayersProps {
  serves1: number | undefined;
  serves2: number | undefined;
  text1: string;
  text2: string;
  serves1PlayerOne: number | undefined;
  serves1PlayerTwo: number | undefined;
  serves2PlayerOne: number | undefined;
  serves2PlayerTwo: number | undefined;
  teamOnePlayerOneName: string;
  teamOnePlayerTwoName: string;
  teamTwoPlayerOneName: string;
  teamTwoPlayerTwoName: string;
}

function MatchCardWithPlayers({
  serves1 = 0,
  serves2 = 0,
  text1 = '',
  text2 = '',
  serves1PlayerOne = 0,
  serves1PlayerTwo = 0,
  serves2PlayerOne = 0,
  serves2PlayerTwo = 0,
  teamOnePlayerOneName = '',
  teamOnePlayerTwoName = '',
  teamTwoPlayerOneName = '',
  teamTwoPlayerTwoName = '',
}: MatchCardWithPlayersProps) {
  return (
    <div className='flex min-h-[110px] flex-wrap border-b sm:flex-nowrap'>
      <div className='order-2 flex w-1/2 flex-col items-center justify-center p-2  sm:order-1 sm:w-1/3 sm:p-0 '>
        <div className='flex flex-col items-center justify-center'>
          <div>
            <span className='font-bold'>{serves1}</span>
          </div>
          <div className='text-xs'>
            {serves1PlayerOne && serves1PlayerOne > 0 ? (
              <span>
                {teamOnePlayerOneName} {serves1PlayerOne}
              </span>
            ) : null}
            {serves1PlayerTwo && serves1PlayerTwo > 0 ? (
              <span>{` | ${teamOnePlayerTwoName} ${serves1PlayerTwo}`}</span>
            ) : null}
          </div>
        </div>
      </div>
      <div className='order-1 flex w-full flex-col items-center justify-center text-center  sm:order-2 sm:w-1/3'>
        <h5 className='font-bold'>{text1}</h5>
        <h6 className='text-xs'>{text2}</h6>
      </div>
      <div className='order-2 flex w-1/2 flex-col items-center justify-center p-2  sm:order-3 sm:w-1/3 sm:p-0 '>
        <div className='flex flex-col items-center justify-center'>
          <div>
            <span className='font-bold'>{serves2}</span>
          </div>
          <div className='text-xs'>
            {serves2PlayerOne && serves2PlayerOne > 0 ? (
              <span>
                {teamTwoPlayerOneName} {serves2PlayerOne}
              </span>
            ) : null}
            {serves2PlayerTwo && serves2PlayerTwo > 0 ? (
              <span>{` | ${teamTwoPlayerTwoName} ${serves2PlayerTwo}`}</span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MatchCardWithPlayers;
